/**
 * Build a SonarCloud project-overview URL for a given Sonar project.
 *
 * Used by the Code Quality tab on /metric-view to drill through from a repo
 * row (US5) or trend card footer (US4) to the canonical SonarCloud page.
 *
 * Pure client-side; no MCP or backend hop required (D8 in the spec).
 *
 * @param organization - Sonar organization slug (may be null when the project
 *   was registered without one — rare but possible). Omitted from the URL when
 *   absent.
 * @param projectKey - Sonar project key (always required).
 */
export function buildSonarCloudUrl(
  organization: string | null,
  projectKey: string,
): string {
  const base = 'https://sonarcloud.io/project/overview';
  const params = new URLSearchParams({ id: projectKey });
  if (organization) {
    params.set('organization', organization);
  }
  return `${base}?${params.toString()}`;
}
